import { Component, computed } from '@angular/core';
import { NetworkConnectionService } from '../../services/network-connection.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offline',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offline.component.html',
  styleUrl: './offline.component.css'
})
export class OfflineComponent {

  showBanner = computed(() => !this.network.online())
  constructor(private readonly network: NetworkConnectionService) {}
}
